import type { CourseModule } from "@/core/types";
import { lektionUebergaenge } from "./lektion-01-uebergaenge";
import { lektionAnimationen } from "./lektion-02-animationen";
import { lektionAnimationGesamtcheck } from "./lektion-03-gesamtcheck";

/**
 * Animationen und Folienübergänge kommen im PowerPoint-Namespace von Office.js
 * überhaupt nicht vor – anders als etwa Alternativtexte ist das keine Frage der
 * PowerPoint-Version. Geprüft wird deshalb über VBA-Prüfmakros, die
 * SlideShowTransition und TimeLine.MainSequence jeder Folie auslesen.
 */
export const modulAnimationen: CourseModule = {
  id: "animationen",
  title: "Animationen und Übergänge",
  summary:
    "Übergänge zwischen Folien und Animationen einzelner Objekte – sparsam eingesetzt " +
    "und so, dass jede Folie auch ohne sie funktioniert. Geprüft wird über Prüfmakros, " +
    "weil Office.js beides nicht kennt.",
  level: "Aufbau",
  lessons: [lektionUebergaenge, lektionAnimationen, lektionAnimationGesamtcheck],
};
